	import { BaseTLDetailComponent,  SettingFilter, SettingService,  AxiosResponse, RightHelper } from "../../../Infrastructure/CorBase/CoreBase";
	
	export default class SettingDetailBase extends BaseTLDetailComponent {
		//VaPTODO - sdilenou funkcionalitu co jsem rozkopiroval i do SettingDetail.vue idealne zkusit nejak presunout do spolecne tridy, mixinu nebo nejak jinak implementovat pouze jednou
		//        - prime dedeni neni mozne, jelikoz list a detail musi mit jineho predka ;-(
		paramTypeGlobal: string = 'global';
		paramTypeTenant: string = 'tenant';
		paramTypeUser: string = 'user';

		moduleList = [{ value: 'COR_PRVNI', text: 'prvni', identif: '' }, { value: 'COR_DRUHY', text: 'druhy', identif: '' }];
		languageList = [{ value: 'COR_PRVNI', text: 'prvni', identif: '' }, { value: 'COR_DRUHY', text: 'druhy', identif: '' }];

		createdBase() {
			this.allowEdit = Number(this.idUserFromParam) == this.idUserFromStore;
		}

		get idUserFromParam(): number | undefined {
			let userIdString: string = this.idUserFromParamString;
			if (userIdString != null && (userIdString !== '') && !isNaN(Number(userIdString))) {
				return Number(userIdString);
			}
			return undefined;
		}

		get idUserFromParamString(): string {
			return String(this.$router.currentRoute.query.userId);
		}

		get idUserFromStore(): number {
			return Number(this.$store.state.idUser);
		}

		get idUser(): number {
			let userId: number = this.idUserFromStore;
			if (this.idUserFromParam != undefined) {
				userId = this.idUserFromParam;
			}
			return userId;
		}

		get idTenant(): number {
			return Number(this.$store.state.idTenant);
		}

		get typeFromParam(): string {
			return String(this.$router.currentRoute.query.type);
		}

		get showSaveButtonByFormData(): boolean {
			//VaP - pokud neni nastavena, jako editovatelna polozka, tak ho muze upravit pouze uzivateli s pravy COR_Setting_Global
			return this.formData.isEditable || RightHelper.currentUserHasRight('COR_Setting_Global');
		}

		get canSeeThisItem(): boolean {
			//VaP - pokud neni nastavena, jako viditelna polozka, tak ho muze videt pouze uzivateli s pravy COR_Setting_Global
			return this.formData.isVisible || RightHelper.currentUserHasRight('COR_Setting_Global');
		}

		get paramType(): string {
			if (this.formData.isSettingGlobal) {
				return this.paramTypeGlobal;
			} else if (this.formData.isSettingTenant) {
				return this.paramTypeTenant;
			}
			return this.paramTypeUser;
		}

		get settingId(): number {
			return this.objectIdFromQuery;
		}

		settingService: SettingService = new SettingService();
		returnRoute: string = "SettingUserList";

		//VaPTODO - dodelat formData
		formData = {
			id: 0,
			idTenant: this.idTenant,
			idUser: 0,
			name: '',
			description: '',
			isType: 0,
			identifier: '',
			defaultValue: '',
			idSettingGroup: 1,
			valueNum: 1,
			valueStr: '',
			valueBol: false,
			valueDec: 1.33,
			valueTime: '1:0:2',
			isString: false,
			isNumber: false,
			isBoolean: false,
			isDecimal: false,
			isTime: false,
			isEnum: false,
			isEnumOwn: false,
			valueEnum: '',
			valueEnumType: '',
			isEditable: false,
			isVisible: false,
			isSettingGlobal: false,
			isSettingTenant: false,
			isSettingUser: false,
			idEnuTypeIdentif: '',
			idEnuTypeName: '',
			idEnuType: 0,
			isEnumModulePart: false,
			isEnumPreferedLanguage: false,
			modulePartName: '',
			preferredLanguageName: ''
		};

		getBackLocation() {
			return {
				name: this.returnRoute, params: { type: this.typeFromParam, userId: this.idUserFromParamString },
				 query: { type: this.typeFromParam, userId: this.idUserFromParamString }			};
		}

		protected goBack(): void {
			
			var pageBack = "SettingUserList";
			if (this.paramType == "tenant") {
				pageBack = "SettingTenantList";
			}
			else if (this.paramType == "global") {
				pageBack = "SettingGlobalList";
			}
			this.$router.push({
				name: pageBack, params: { type: this.typeFromParam, goBack: pageBack, userId: this.idUserFromParamString, nameUser: this.$router.currentRoute.params.nameUser }
				, query: {
					type: this.typeFromParam, goBack: pageBack, userId: this.idUserFromParamString, nameUser: String(this.$router.currentRoute.query.nameUser)
					, idSettingGroup: String(this.$route.query['idSettingGroup'])
				}
			});
			//this.$router.push({
			//	name: this.returnRoute, params: { type: this.typeFromParam, goBack: this.getGoBack, userId: this.idUserFromParamString, nameUser: this.$router.currentRoute.params.nameUser }
			//	, query: {
			//		type: this.typeFromParam, goBack: this.getGoBack, userId: this.idUserFromParamString, nameUser: String(this.$router.currentRoute.query.nameUser)
			//		, idSettingGroup: String(this.$route.query['idSettingGroup'])
			//	}
			//});
		}

		//tohle se pouzije kdyz se vracim zpet na detail uzivatele (cesta detail nastaveni -> seznam nastaveni -> detail uživatele)
		goBackFromDetail() {
			this.$router.push(this.getBackLocation());
		}

		get getGoBack(): string {
			return String(this.$router.currentRoute.query.goBack);
		}

		initializeRightsLocal() {
			if (this.formData.isSettingGlobal) {
				super.initializeRights(undefined, undefined, 'COR_Setting_Global', 'COR_Setting_Global');
			}
			else if (this.formData.isSettingTenant) {
				super.initializeRights(undefined, undefined, 'COR_Setting_Tenant', 'COR_Setting_Tenant');
			}
			else {
				super.initializeRights(undefined, undefined, 'COR_Setting_User', 'COR_Setting_User');
			}
		}

		isOwner(): boolean {
			return this.formData.isSettingUser && this.idUserFromParam == this.idUserFromStore;
		}

		setIsGlobalSetting() {
			let paramType: string = String(this.$router.currentRoute.query.type);
			if (paramType) {
				this.formData.isSettingGlobal = paramType === this.paramTypeGlobal;
				this.formData.isSettingTenant = paramType === this.paramTypeTenant;
			}
			this.formData.isSettingUser = !(this.formData.isSettingGlobal || this.formData.isSettingTenant);
		}

		protected doAction() {
			super.doCRUDActionWithInfoMessage(this.$t('setting.messageNew').toString(), this.$t('setting.messageEdit').toString(), this.$t('setting.messageDelete').toString());
		}

		protected fetchDataFromServer(): Promise<AxiosResponse<any>> {
			return this.settingService.getByIdWithObjectTypeAndId(this.settingId, this.paramType, this.idTenant, this.idUser);
		}

		protected fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
			return super.NoCall()
		}

		protected refreshItems(items: any, refreshData: any): any {
			return items;
		}

		protected updateObject(): Promise<AxiosResponse<any>> {
			if (this.formData.idTenant == null || this.formData.idTenant == 0) {
				this.formData.idTenant = this.idTenant;
			}
			if (this.formData.idUser == 0 || this.formData.idUser == null) {
				this.formData.idUser = this.idUser;
			}
			this.formData.defaultValue = this.formData.isString ? this.formData.valueStr : this.formData.defaultValue;
			this.formData.defaultValue = this.formData.isNumber ? this.formData.valueNum.toString() : this.formData.defaultValue;
			this.formData.defaultValue = this.formData.isDecimal ? this.formData.valueDec.toString() : this.formData.defaultValue;
			this.formData.defaultValue = this.formData.isTime ? this.formData.valueTime.toString() : this.formData.defaultValue;
			this.formData.defaultValue = this.formData.isBoolean ? (this.formData.valueBol ? "true" : "false") : this.formData.defaultValue;
			this.formData.defaultValue = this.formData.isEnumModulePart ? this.formData.valueStr : this.formData.defaultValue;
			this.formData.defaultValue = this.formData.isEnumPreferedLanguage ? this.formData.valueStr : this.formData.defaultValue;
			

			if (this.formData.isEnum) {
				this.formData.idEnuTypeName = this.stateText('idEnuType');
				this.formData.defaultValue = this.formData.isEnum ? this.formData.idEnuTypeName.toString() : this.formData.defaultValue;
			}
			if (this.formData.isEnumModulePart) {
				this.formData.modulePartName = this.stateText('idModulePart');
			}
			//TODO aa
			if (this.formData.isEnumPreferedLanguage) {
				this.formData.preferredLanguageName = this.stateText('idPreferredLanguage');
			}
			//promitnuti zmeny nastaveni postup Global / Tenant / User
			if (this.formData.idEnuTypeIdentif == 'ENU_COR_Setting_Page' && this.$store.state.idUser == this.formData.idUser) {
				this.isExistSaveSetting(this.formData.defaultValue);		
			}
			if (this.formData.identifier == 'SET_OAuth_Enabled') {
				this.$store.commit("allowOAuth", this.formData.defaultValue);
			}
			if (this.formData.identifier == 'SET_Update_Page_Timer') {
				this.$store.commit("pageTimer", this.formData.defaultValue);
			}
			if (this.formData.identifier == 'SET_Search_Ignore_Diacritics') {
				this.$store.commit("ignoreDiacritics", this.formData.defaultValue);
			}
			if (this.formData.identifier == 'SET_GlobalSearch_Dialog_Item_Count') {
				this.$store.commit("globalSearchItemCount", this.formData.defaultValue);
			}
			this.saveSettingStore(this.formData.identifier);

			return this.settingService.update(this.objectId, this.formData);
		}

		private saveSettingStore(identifier: string) {
			if (identifier == 'SET_Ask_Before_Delete') {
				this.$store.commit("askBeforeDelete", this.formData.defaultValue == 'true');
			}
			else if (identifier == 'SET_Show_Info_Message_OnDetail') {
				this.$store.commit("showInfoMessagesOnDetail", this.formData.defaultValue == 'true');
			}
			else if (identifier == 'SET_Ask_Before_Cancel_Editing') {
				this.$store.commit("askBeforeCancelEditing", this.formData.defaultValue == 'true');
			}
			else if (identifier == 'SET_Show_Detail_Params') {
				this.$store.commit("setShowDetailParamFirstShow", this.formData.defaultValue == 'true');
			}
        }

		private async isExistSaveSetting(perPage: string) {
			var change = true;

			if (this.formData.isSettingGlobal || this.formData.isSettingTenant) {
				let settingFilterUser: SettingFilter = new SettingFilter('', false, false, true, null
					, this.formData.idUser, 'SET_Count_Page');
				
				var resultUser = await this.settingService.getAllByFilter(settingFilterUser);
				if (resultUser.data[0].idUser > 0) {
					change = false;
				}
			}
			if (this.formData.isSettingGlobal) {
				let filterTenant: SettingFilter = new SettingFilter('', false, true, false, this.$store.state.idTenant
					, null, 'SET_Count_Page');
				var resultTenant = await this.settingService.getAllByFilter(filterTenant);
				if (resultTenant.data[0].idTenant > 0) {
					change = false;
				}
			}
			if (change) {
				this.$store.commit("perPage", this.formData.defaultValue);
			}			
		}

		private stateText(name: string): string {
			var e = (document.getElementById(name)) as HTMLSelectElement;
			if (e.selectedOptions[0] == undefined) {
				return 'nic';
			}
			return e.selectedOptions[0].innerText;
		}

		validateIfUserCanSeeThisItem() {
			if (!this.canSeeThisItem) {
				// VaPTODO - je potreba domyslet, at se zobrazi chybova zprava a pak teprve dojde k presmerovani na jinou stranku
				this.showErrorMessage(this.$t('setting.messageShowError').toString());
				this.goBackFromDetail();
			}
		}

		get showSaveButtonChild(): boolean {
			return this.showSaveButton && this.showSaveButtonByFormData;
		}


		//processResponseToFormData(response: any) {
		protected processResponse(response: AxiosResponse<any>): void {		
		
		this.formData.id = response.data.id;
		this.formData.identifier = response.data.identifier;
		this.formData.idTenant = response.data.idTenant;
		this.formData.idUser = response.data.idUser;
		this.formData.name = response.data.name;
		this.formData.description = response.data.description;
		this.formData.isEditable = response.data.isEditableRow || RightHelper.currentUserIsSuperUser();
		this.onlyShow = this.onlyShow || !this.showSaveButtonChild;
		this.formData.isVisible = response.data.isVisible || RightHelper.currentUserIsSuperUser();
		this.formData.valueStr = response.data.defaultValue;
		this.formData.idSettingGroup = response.data.idSettingGroup;
		this.formData.isString = response.data.isString;
		this.formData.isNumber = response.data.isNumber;
		this.formData.isBoolean = response.data.isBoolean;
		this.formData.isTime = response.data.isTime;
		this.formData.isDecimal = response.data.isDecimal;
		this.formData.isEnum = response.data.isEnum;
		this.formData.isEnumOwn = response.data.isEnumOwn;
		this.formData.isEnumModulePart = response.data.isEnumModulePart;
		this.formData.idEnuTypeIdentif = response.data.idEnuTypeIdentif;
		this.formData.idEnuType = response.data.idEnuType;
		this.formData.modulePartName = response.data.modulePartName;
		this.formData.idEnuTypeName = response.data.idEnuTypeName;

		this.formData.isEnumPreferedLanguage = response.data.isEnumPreferedLanguage;
		this.formData.preferredLanguageName = response.data.preferredLanguageName;

		//vyber home stranky
		if (this.formData.isEnumModulePart) {
			this.moduleList = [];
			for (var i = 0; i < response.data.modulePartList.length; i++) {
				var item = (response.data.modulePartList[i] as string).split(';');
				if (this.$store.state.tenantModules.filter((c: any) => c.identifier == item[0] && c.isVisible == true ).length > 0) {

				this.moduleList.push({ value: item[0], text: item[1], identif: '' });
				if (item[1] == this.formData.valueStr) {
					this.formData.valueStr = item[0];
					this.formData.modulePartName = item[1];
				}
			}
			}

			this.moduleList = this.moduleList.sort((a: any, b: any) => (a.text ? a.text.localeCompare(b.text) : -1));
		}

		//vyber jazyka
		if (this.formData.isEnumPreferedLanguage) {
			this.languageList = [];
			for (var i = 0; i < response.data.languagesList.length; i++) {
				var item = (response.data.languagesList[i] as string).split(';');
				this.languageList.push({ value: item[0], text: item[1], identif: '' });
				if (response.data.defaultValue == item[0]) {
					this.formData.preferredLanguageName = item[1];
                }
			}
		}

			if (this.formData.isTime) {
				var regex = new RegExp('^\\d{1,2}:\\d{2}(:\\d{2})?$');
				if (!regex.test(response.data.defaultValue)) {
					response.data.defaultValue = '00:00';
				}
			}

			this.formData.valueDec = response.data.defaultValue;
			this.formData.valueTime = response.data.defaultValue;
			this.formData.valueNum = response.data.defaultValue;
			this.formData.valueBol = response.data.defaultValue == "true" ? true : false;
		}

		vIsCorrectValue: boolean = true;

		validateBase() {
			return !this.vIsCorrectValue;
		}

		isCorrectValueBase(value: any) {
			this.vIsCorrectValue = value;
		}

		//TODO pryc
		errorText() {

		}
	}




